module.exports = __webpack_public_path__ + "media/lineas/1-17033710.png";